import React, { useState } from "react";
import API_URL from "../apiConfig";
import "../styles/Settings.css";

function Settings({ user, token, onLogout }) {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    try {
      const res = await fetch(`${API_URL}/api/auth/change-password`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: user.id || user._id,
          oldPassword,
          newPassword,
        }),
      });
      const data = await res.json();
      if (!res.ok || data.error) {
        setMessage(data.error || "Failed to change password. Try again.");
      } else {
        setMessage("Password changed successfully!");
        setOldPassword("");
        setNewPassword("");
      }
    } catch {
      setMessage("Failed to change password. Try again.");
    }
    setLoading(false);
  };

  return (
    <div className="settings-container">
      <h2>Settings</h2>
      <form className="settings-form" onSubmit={handleChangePassword}>
        <div className="settings-field">
          <label>Old Password</label>
          <input
            type="password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            required
            placeholder="Enter old password"
            autoComplete="current-password"
          />
        </div>
        <div className="settings-field">
          <label>New Password</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={6}
            placeholder="Enter new password"
            autoComplete="new-password"
          />
        </div>
        <button type="submit" className="settings-btn" disabled={loading}>
          {loading ? "Changing..." : "Change Password"}
        </button>
      </form>
      {message && (
        <div className={`settings-message ${message.toLowerCase().includes("success") ? "success" : "error"}`}>
          {message}
        </div>
      )}
      <hr />
      <div style={{ marginBottom: 16 }}>
        <strong>Name:</strong> {user?.name || user?.full_name || user?.email || "-"}
        <br />
        <strong>Email:</strong> {user?.email || "-"}
        <br />
        <strong>Role:</strong> {user?.role || "-"}
      </div>
      <button className="settings-btn logout" onClick={onLogout}>Logout</button>
    </div>
  );
}

export default Settings;